import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import ContactPage2 from '../Components/ContactPage2'

export default function ContactPage() {
  return (
    <>
      <Navbar />
      <ContactPage2 />
      {/* <Contact /> */}
      <Footer />
    </>
  )
}
